export default "__VITE_ASSET__C7G1Nis___"